// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.et_pb_row_13.et_pb_row {
    margin-top: 0px !important;
    padding-top: 0.5em;
}

@media only screen and (min-width: 992px) {
    .et_pb_row {
        width: 100% !important;
    }
}

.et_pb_text_inner {
    position: relative;
}

.et_pb_text_align_left {
    text-align: left;
}
.et_pb_text_inner {
    position: relative;
}
.et_pb_text>:last-child {
    padding-bottom: 0;
}


@media only screen and (min-width: 992px) {
    div.et_pb_section.et_pb_section_5, .et_pb_section_6 {
        padding: 40px 0 !important;
    }
    div.et_pb_section.et_pb_section_0 {
        padding: 30px 0;
        background-size: cover !important;
        width: 100% !important;
    }
    .why_mfine h4, .oc_work h2, .testimonial h2 {
        font-weight: 600 !important;
        font-size: 40px !important;
        line-height: 30px !important;
        color: #1A72A0 !important;
        text-align: left !important;
        padding-bottom: 50px !important;
    }
    .et_pb_row {
        width: 100% !important;
    }
    .oc_work .et_pb_column_1_3 {
        width: 8% !important;
        margin: 0 15px 0 0;
        padding-bottom: 85px;
    }
    .oc_work .et_pb_column_1_3 {
        width: 8% !important;
        margin: 0 15px 0 0;
        padding-bottom: 85px;
    }
    .oc_work .et_pb_column_2_3 {
        width: 70% !important;
    }
    .oc_work .odc_rows:before {
        content: "";
        position: absolute;
        z-index: 0;
        bottom: 0;
        left: 4%;
        top: 25%;
        border-left: 2px dotted #3D94C1;
    }
    .icon_style h5, .oc_work h3 {
        font-weight: 600 !important;
        font-size: 25px;
        line-height: 38px;
        color: #242424;
    }
    .et_pb_row .et_pb_column.et-last-child, .et_pb_row .et_pb_column:last-child, .et_pb_row_inner .et_pb_column.et-last-child, .et_pb_row_inner .et_pb_column:last-child {
        margin-right: 0 !important;
    }
    .oc_work img {
        width: 85px;
    }
    .oc_work .odc_rows:before {
        content: "";
        position: absolute;
        z-index: 0;
        bottom: 0;
        left: 4%;
        top: 25%;
        border-left: 2px dotted #3D94C1;
    }
}

.et_pb_row {
    max-width: 1280px !important;
}

.et_pb_row:after, .et_pb_row_inner:after, .et_pb_slides:after {
    display: block;
    visibility: hidden;
    clear: both;
    width: 0;
    height: 0;
    line-height: 0;
    content: ".";
}
.et_pb_row {
    position: relative;
    width: 80%;
    max-width: 1080px;
    margin: auto;
}

.et_pb_column {
    float: left;
    position: relative;
    z-index: 9;
    background-position: center;
    background-size: cover;
}

.et_pb_row_18:last-child::after
{
    content: '';
}

.main_titles
{
    font-size: 2.4rem;
    font-weight: 600;
}


@media only screen and (min-width: 992px) {
    .et_pb_section.et_pb_section_4 {
        background-image: linear-gradient(360deg, #F9F3FE 47%, #F7FCFF 68%, #F7FCFF 20%) !important;
    }
    .et_pb_section_4 {
        padding: 50px 0 !important;
        margin-top: 40px;
    }
    .oc_work .et_pb_column_2_3 {
        width: 70% !important;
    }
    .oc_work .odc_rows:before {
        content: "";
        position: absolute;
        z-index: 0;
        bottom: 0;
        left: 4%;
        top: 25%;
        border-left: 2px dotted #3D94C1;
    }
}

@media only screen and (max-width: 486px) {
.specialities-wrap
{
    padding: 15px !important;
}
}

.et_pb_text>:last-child {
    padding-bottom: 0;
}
.et_pb_text_inner {
    position: relative;
}

@media only screen and (min-width: 992px) {
    .why_mfine h4, .oc_work h2, .testimonial h2 {
        font-weight: 600 !important;
        font-size: 40px !important;
        line-height: 30px !important;
        color: #1A72A0 !important;
        text-align: left !important;
        padding-bottom: 50px !important;
    }
    .et_pb_row_9 {
        max-width: 1280px !important;
    }
}

@media (min-width: 981px) {
    .et_pb_gutters3 .et_pb_column_1_2, .et_pb_gutters3.et_pb_row .et_pb_column_1_2 {
        width: 47.25%;
    }
}
.et_pb_text_align_left {
    text-align: left;
}


@media only screen and (min-width: 992px) {
    .icon_style h5, .oc_work h3 {
        font-weight: 600 !important;
        font-size: 25px;
        line-height: 38px;
        color: #242424;
    }
    .read-more-wrap, .icon_style p, .oc_work p {
        font-weight: 500;
        font-size: 14px;
        line-height: 24px;
        color: #242424;
        padding: 0;
    }
    .read-more-wrap, .icon_style p, .oc_work p {
        font-weight: 500;
        font-size: 14px;
        line-height: 24px;
        color: #242424;
        padding: 0;
    }
}

.et_pb_column {
    float: left;
    position: relative;
    z-index: 9;
    background-position: center;
    background-size: cover;
}

.et_pb_text_inner {
    position: relative;
}

@media only screen and (min-width: 992px) {
    .read-more-wrap, .icon_style p, .oc_work p {
        font-weight: 500;
        font-size: 14px;
        line-height: 24px;
        color: #242424;
        padding: 0;
    }
}

@media only screen and (min-width: 992px) {
    .icon_style h5, .oc_work h3 {
        font-weight: 600 !important;
        font-size: 25px;
        line-height: 38px;
        color: #242424;
    }
}

@media only screen and (min-width: 992px) {
    .read-more-wrap, .icon_style p, .oc_work p {
        font-weight: 500;
        font-size: 14px;
        line-height: 24px;
        color: #242424;
        padding: 0;
    }
}

.et_pb_column {
    float: left;
    position: relative;
    z-index: 9;
    background-position: center;
    background-size: cover;
}

@media only screen and (min-width: 992px) {
    .icon_style img {
        float: left;
        margin-right: 10px;
        width: 80px;
    }
}

@media only screen and (max-width: 767px) {
    .why_mfine h4 {
        font-weight: 600 !important;
        font-size: 18px;
        line-height: 27px;
        color: #1A72A0;
    }
    .why_mfine .et_pb_row_9, .why_mfine .et_pb_row_10, .why_mfine .et_pb_row_11, .why_mfine .et_pb_row_12, .why_mfine .et_pb_row_13, .why_mfine .et_pb_row_14 {
        padding: 0;
        width: 90% !important;
    }
    .icon_style img {
        width: 50px;
    }
    .specialities-wrap
    {
        padding: 15px;
    }
}


/*  appointment css */

.main-wrapper.home-ten .need-to-know-section.steps-to-follow .box-detail {
    background: #ffffff;
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: 24px;
    padding: 24px;
    box-shadow: 0px 7.5px 17.5px 0px rgba(0, 0, 0, 0.0509803922);
    display: flex;
    align-items: center;
    justify-content: center;
}

.main-wrapper.home-ten .need-to-know-section.steps-to-follow .box-detail .steps-list-box {
    position: relative;
}

.main-wrapper.home-ten .need-to-know-section.steps-to-follow .box-detail .steps-list-box .steps-list-img {
    width: 140px;
    height: 60px;
    margin: 0 auto 10px;
}

.main-wrapper.home-ten .need-to-know-section.steps-to-follow .box-detail .steps-list-box span {
    color: #0E82FD;
    font-weight: 700;
    font-size: 30px;
    position: absolute;
    left: 50%;
    transform: translate(-50%, 12%);
}

.main-wrapper.home-ten .need-to-know-section.steps-to-follow .box-detail .steps-list-box h6 {
    font-weight: 600;
    font-size: 18px;
    margin-bottom: 10px;
    color: #000000;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
}

.main-wrapper.home-ten .need-to-know-section.steps-to-follow .box-detail .steps-list-box p {
    font-size: 14px;
    color: #374151;
    text-align: center;
    margin-bottom: 0;
}

.main-wrapper.home-ten .need-to-know-section.steps-to-follow .bg-shapes img {
    position: absolute;
    bottom: 59px;
    right: 0;
    z-index: -1;
}

/*  faq's section */


.frequently-section-fifteen .faq-main-cards .faq-card {
    box-shadow: 0px 7.5px 17.5px 0px rgba(0, 0, 0, 0.0509803922);
    background: #ffffff;
    border-radius: 10px;
    padding: 15px;
    margin-bottom: 24px;
}

.frequently-section-fifteen .faq-main-cards .faq-card .faq-title a {
    font-size: 20px;
    color: #000000;
    width: 100%;
    font-weight: 600;
    display: block;
    position: relative;
}

.frequently-section-fifteen .faq-main-cards .faq-card .card-collapse p {
    color: #374151;
    margin-bottom: 0;
    margin-top: 15px;
    padding-top: 15px;
    border-top: 1px solid #E5E7EB;
}

.frequently-section-fifteen .faq-main-cards .faq-card .faq-title a:after {
    content: "+";
    width: 32px;
    height: 32px;
    border-radius: 50%;
    position: absolute;
    right: 0px;
    top: 50%;
    transform: translateY(-50%);
    transition: 0.5s all;
    font-family: "Font Awesome 6 free";
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
}

.frequently-section-fifteen .faq-main-cards .faq-card .faq-title a:not(.collapsed)::after {
    content: "\\f068";
    background: #0E82FD;
    color: #ffffff;
}

.frequently-section-fifteen .faq-main-cards .faq-card .faq-title a:after {
    content: "+";
    width: 32px;
    height: 32px;
    border-radius: 50%;
    position: absolute;
    right: 0px;
    top: 50%;
    transform: translateY(-50%);
    transition: 0.5s all;
    font-family: "Font Awesome 6 free";
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
}


.specialities-section-one {
    background: none;
    position: relative;
}

.specialities-section-one::before {
    content: "";
    width: 100%;
    height: 80%;
    position: absolute;
    top: 0;
    left: 0;
    background: #0E82FD;
    z-index: -1;
}

.section-header-one {
    margin-bottom: 50px;
    text-align: center;
}

.specialities-section-one .section-header-one h2 {
    color: #ffffff;
}

.section-header-one .section-title {
    display: inline-block;
    position: relative;
}
.section-header-one h2 {
    font-size: 30px;
    font-weight: 600;
    color: #000000;
    margin-bottom: 15px;
}

.specialities-section-one .specialities-block {
    margin-bottom: 26px;
}

/* .specialities-section-one .specialities-block .specialities-item {
    background: #0E82FD;
    border: 1px solid #ffffff;
    border-radius: 10px;
    height: auto;
    margin: 56px 0 24px;
    padding: 0 24px 24px;
    cursor: pointer;
    -webkit-transition: 0.7s;
    -ms-transition: 0.7s;
    transition: 0.7s;
    display: block;
} */

/* .specialities-section-one .specialities-block .specialities-img {
    margin: -56px 0 30px;
    padding: 0;
} */

.specialities-section-one .specialities-block .specialities-img .hexogen {
    border: none;
    width: 87px;
    height: 100px;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 0;
    transition: 0.7s;
    margin: 0 auto;
}

.specialities-section-one .specialities-block .specialities-img .hexogen img {
    width: auto;
    transition: 0.4s;
}

.specialities-wrap {
    background-image: linear-gradient(53deg, #1383c6, #63bd46) !important;
    padding: 80px;
    border-radius: 10px;
    /* background-image: url(../img/choose-img.jpg); */
    background-repeat: no-repeat;
    background-position: right;
}

.specialities-wrap .special-content h2 {
    color: #ffffff;
    font-weight: 600;
    margin-bottom: 24px;
}

.specialities-wrap .special-content h4 {
    color: #ffffff;
    font-weight: 600;
    font-size: 20px;
    margin-bottom: 10px;
}

.specialities-wrap .special-content p {
    color: #ffffff;
    margin-bottom: 40px;
}

.specialities-wrap .special-content .special-btn a.btn-primary {
    box-shadow: inset 0 0 0 0 #000C18;
}

.specialities-wrap .special-content .special-btn a {
    margin-right: 10px;
}
.btn-primary {
    background-color: #0E82FD;
    border: 1px solid #0E82FD;
    box-shadow: inset 0 0 0 0 #ffffff;
}

.specialities-wrap .special-content .special-btn a:last-child {
    margin-right: 0;
}

.specialities-wrap .special-content .special-btn a {
    margin-right: 10px;
}
.btn-outline-primary {
    background-color: transparent;
    border: 1px solid #ffffff;
    box-shadow: inset 0 0 0 0 #ffffff;
    color: #ffffff;
}
.btn {
    border-radius: 35px;
    font-weight: 600;
    font-size: 16px;
    padding: 11px 24px;
}`, "",{"version":3,"sources":["webpack://./src/pages/services/VirtualConsultation.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;;;AAGA;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,eAAe;QACf,iCAAiC;QACjC,sBAAsB;IAC1B;IACA;QACI,2BAA2B;QAC3B,0BAA0B;QAC1B,4BAA4B;QAC5B,yBAAyB;QACzB,2BAA2B;QAC3B,+BAA+B;IACnC;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,oBAAoB;QACpB,kBAAkB;QAClB,oBAAoB;IACxB;IACA;QACI,oBAAoB;QACpB,kBAAkB;QAClB,oBAAoB;IACxB;IACA;QACI,qBAAqB;IACzB;IACA;QACI,WAAW;QACX,kBAAkB;QAClB,UAAU;QACV,SAAS;QACT,QAAQ;QACR,QAAQ;QACR,+BAA+B;IACnC;IACA;QACI,2BAA2B;QAC3B,eAAe;QACf,iBAAiB;QACjB,cAAc;IAClB;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;QACX,kBAAkB;QAClB,UAAU;QACV,SAAS;QACT,QAAQ;QACR,QAAQ;QACR,+BAA+B;IACnC;AACJ;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,SAAS;IACT,cAAc;IACd,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,iBAAiB;IACjB,gBAAgB;AACpB;;;AAGA;IACI;QACI,2FAA2F;IAC/F;IACA;QACI,0BAA0B;QAC1B,gBAAgB;IACpB;IACA;QACI,qBAAqB;IACzB;IACA;QACI,WAAW;QACX,kBAAkB;QAClB,UAAU;QACV,SAAS;QACT,QAAQ;QACR,QAAQ;QACR,+BAA+B;IACnC;AACJ;;AAEA;AACA;;IAEI,wBAAwB;AAC5B;AACA;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,2BAA2B;QAC3B,0BAA0B;QAC1B,4BAA4B;QAC5B,yBAAyB;QACzB,2BAA2B;QAC3B,+BAA+B;IACnC;IACA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;AACA;IACI,gBAAgB;AACpB;;;AAGA;IACI;QACI,2BAA2B;QAC3B,eAAe;QACf,iBAAiB;QACjB,cAAc;IAClB;IACA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,cAAc;QACd,UAAU;IACd;IACA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,cAAc;QACd,UAAU;IACd;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,cAAc;QACd,UAAU;IACd;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,eAAe;QACf,iBAAiB;QACjB,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,cAAc;QACd,UAAU;IACd;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI;QACI,WAAW;QACX,kBAAkB;QAClB,WAAW;IACf;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,eAAe;QACf,iBAAiB;QACjB,cAAc;IAClB;IACA;QACI,UAAU;QACV,qBAAqB;IACzB;IACA;QACI,WAAW;IACf;IACA;;QAEI,aAAa;IACjB;AACJ;;;AAGA,qBAAqB;;AAErB;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,4DAA4D;IAC5D,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,WAAW;AACf;;AAEA,mBAAmB;;;AAGnB;IACI,4DAA4D;IAC5D,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,oBAAoB;IACpB,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,oBAAoB;IACpB,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;;AAGA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;;;;;;;;;;;GAYG;;AAEH;;;GAGG;;AAEH;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,4BAA4B;IAC5B,2BAA2B;IAC3B,gBAAgB;IAGhB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IAGX,gBAAgB;AACpB;;AAEA;IACI,qEAAqE;IACrE,aAAa;IACb,mBAAmB;IACnB,kDAAkD;IAClD,4BAA4B;IAC5B,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,iCAAiC;AACrC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,iCAAiC;IACjC,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB","sourcesContent":[".et_pb_row_13.et_pb_row {\n    margin-top: 0px !important;\n    padding-top: 0.5em;\n}\n\n@media only screen and (min-width: 992px) {\n    .et_pb_row {\n        width: 100% !important;\n    }\n}\n\n.et_pb_text_inner {\n    position: relative;\n}\n\n.et_pb_text_align_left {\n    text-align: left;\n}\n.et_pb_text_inner {\n    position: relative;\n}\n.et_pb_text>:last-child {\n    padding-bottom: 0;\n}\n\n\n@media only screen and (min-width: 992px) {\n    div.et_pb_section.et_pb_section_5, .et_pb_section_6 {\n        padding: 40px 0 !important;\n    }\n    div.et_pb_section.et_pb_section_0 {\n        padding: 30px 0;\n        background-size: cover !important;\n        width: 100% !important;\n    }\n    .why_mfine h4, .oc_work h2, .testimonial h2 {\n        font-weight: 600 !important;\n        font-size: 40px !important;\n        line-height: 30px !important;\n        color: #1A72A0 !important;\n        text-align: left !important;\n        padding-bottom: 50px !important;\n    }\n    .et_pb_row {\n        width: 100% !important;\n    }\n    .oc_work .et_pb_column_1_3 {\n        width: 8% !important;\n        margin: 0 15px 0 0;\n        padding-bottom: 85px;\n    }\n    .oc_work .et_pb_column_1_3 {\n        width: 8% !important;\n        margin: 0 15px 0 0;\n        padding-bottom: 85px;\n    }\n    .oc_work .et_pb_column_2_3 {\n        width: 70% !important;\n    }\n    .oc_work .odc_rows:before {\n        content: \"\";\n        position: absolute;\n        z-index: 0;\n        bottom: 0;\n        left: 4%;\n        top: 25%;\n        border-left: 2px dotted #3D94C1;\n    }\n    .icon_style h5, .oc_work h3 {\n        font-weight: 600 !important;\n        font-size: 25px;\n        line-height: 38px;\n        color: #242424;\n    }\n    .et_pb_row .et_pb_column.et-last-child, .et_pb_row .et_pb_column:last-child, .et_pb_row_inner .et_pb_column.et-last-child, .et_pb_row_inner .et_pb_column:last-child {\n        margin-right: 0 !important;\n    }\n    .oc_work img {\n        width: 85px;\n    }\n    .oc_work .odc_rows:before {\n        content: \"\";\n        position: absolute;\n        z-index: 0;\n        bottom: 0;\n        left: 4%;\n        top: 25%;\n        border-left: 2px dotted #3D94C1;\n    }\n}\n\n.et_pb_row {\n    max-width: 1280px !important;\n}\n\n.et_pb_row:after, .et_pb_row_inner:after, .et_pb_slides:after {\n    display: block;\n    visibility: hidden;\n    clear: both;\n    width: 0;\n    height: 0;\n    line-height: 0;\n    content: \".\";\n}\n.et_pb_row {\n    position: relative;\n    width: 80%;\n    max-width: 1080px;\n    margin: auto;\n}\n\n.et_pb_column {\n    float: left;\n    position: relative;\n    z-index: 9;\n    background-position: center;\n    background-size: cover;\n}\n\n.et_pb_row_18:last-child::after\n{\n    content: '';\n}\n\n.main_titles\n{\n    font-size: 2.4rem;\n    font-weight: 600;\n}\n\n\n@media only screen and (min-width: 992px) {\n    .et_pb_section.et_pb_section_4 {\n        background-image: linear-gradient(360deg, #F9F3FE 47%, #F7FCFF 68%, #F7FCFF 20%) !important;\n    }\n    .et_pb_section_4 {\n        padding: 50px 0 !important;\n        margin-top: 40px;\n    }\n    .oc_work .et_pb_column_2_3 {\n        width: 70% !important;\n    }\n    .oc_work .odc_rows:before {\n        content: \"\";\n        position: absolute;\n        z-index: 0;\n        bottom: 0;\n        left: 4%;\n        top: 25%;\n        border-left: 2px dotted #3D94C1;\n    }\n}\n\n@media only screen and (max-width: 486px) {\n.specialities-wrap\n{\n    padding: 15px !important;\n}\n}\n\n.et_pb_text>:last-child {\n    padding-bottom: 0;\n}\n.et_pb_text_inner {\n    position: relative;\n}\n\n@media only screen and (min-width: 992px) {\n    .why_mfine h4, .oc_work h2, .testimonial h2 {\n        font-weight: 600 !important;\n        font-size: 40px !important;\n        line-height: 30px !important;\n        color: #1A72A0 !important;\n        text-align: left !important;\n        padding-bottom: 50px !important;\n    }\n    .et_pb_row_9 {\n        max-width: 1280px !important;\n    }\n}\n\n@media (min-width: 981px) {\n    .et_pb_gutters3 .et_pb_column_1_2, .et_pb_gutters3.et_pb_row .et_pb_column_1_2 {\n        width: 47.25%;\n    }\n}\n.et_pb_text_align_left {\n    text-align: left;\n}\n\n\n@media only screen and (min-width: 992px) {\n    .icon_style h5, .oc_work h3 {\n        font-weight: 600 !important;\n        font-size: 25px;\n        line-height: 38px;\n        color: #242424;\n    }\n    .read-more-wrap, .icon_style p, .oc_work p {\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 24px;\n        color: #242424;\n        padding: 0;\n    }\n    .read-more-wrap, .icon_style p, .oc_work p {\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 24px;\n        color: #242424;\n        padding: 0;\n    }\n}\n\n.et_pb_column {\n    float: left;\n    position: relative;\n    z-index: 9;\n    background-position: center;\n    background-size: cover;\n}\n\n.et_pb_text_inner {\n    position: relative;\n}\n\n@media only screen and (min-width: 992px) {\n    .read-more-wrap, .icon_style p, .oc_work p {\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 24px;\n        color: #242424;\n        padding: 0;\n    }\n}\n\n@media only screen and (min-width: 992px) {\n    .icon_style h5, .oc_work h3 {\n        font-weight: 600 !important;\n        font-size: 25px;\n        line-height: 38px;\n        color: #242424;\n    }\n}\n\n@media only screen and (min-width: 992px) {\n    .read-more-wrap, .icon_style p, .oc_work p {\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 24px;\n        color: #242424;\n        padding: 0;\n    }\n}\n\n.et_pb_column {\n    float: left;\n    position: relative;\n    z-index: 9;\n    background-position: center;\n    background-size: cover;\n}\n\n@media only screen and (min-width: 992px) {\n    .icon_style img {\n        float: left;\n        margin-right: 10px;\n        width: 80px;\n    }\n}\n\n@media only screen and (max-width: 767px) {\n    .why_mfine h4 {\n        font-weight: 600 !important;\n        font-size: 18px;\n        line-height: 27px;\n        color: #1A72A0;\n    }\n    .why_mfine .et_pb_row_9, .why_mfine .et_pb_row_10, .why_mfine .et_pb_row_11, .why_mfine .et_pb_row_12, .why_mfine .et_pb_row_13, .why_mfine .et_pb_row_14 {\n        padding: 0;\n        width: 90% !important;\n    }\n    .icon_style img {\n        width: 50px;\n    }\n    .specialities-wrap\n    {\n        padding: 15px;\n    }\n}\n\n\n/*  appointment css */\n\n.main-wrapper.home-ten .need-to-know-section.steps-to-follow .box-detail {\n    background: #ffffff;\n    border-radius: 10px;\n    overflow: hidden;\n    margin-bottom: 24px;\n    padding: 24px;\n    box-shadow: 0px 7.5px 17.5px 0px rgba(0, 0, 0, 0.0509803922);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.main-wrapper.home-ten .need-to-know-section.steps-to-follow .box-detail .steps-list-box {\n    position: relative;\n}\n\n.main-wrapper.home-ten .need-to-know-section.steps-to-follow .box-detail .steps-list-box .steps-list-img {\n    width: 140px;\n    height: 60px;\n    margin: 0 auto 10px;\n}\n\n.main-wrapper.home-ten .need-to-know-section.steps-to-follow .box-detail .steps-list-box span {\n    color: #0E82FD;\n    font-weight: 700;\n    font-size: 30px;\n    position: absolute;\n    left: 50%;\n    transform: translate(-50%, 12%);\n}\n\n.main-wrapper.home-ten .need-to-know-section.steps-to-follow .box-detail .steps-list-box h6 {\n    font-weight: 600;\n    font-size: 18px;\n    margin-bottom: 10px;\n    color: #000000;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    text-align: center;\n}\n\n.main-wrapper.home-ten .need-to-know-section.steps-to-follow .box-detail .steps-list-box p {\n    font-size: 14px;\n    color: #374151;\n    text-align: center;\n    margin-bottom: 0;\n}\n\n.main-wrapper.home-ten .need-to-know-section.steps-to-follow .bg-shapes img {\n    position: absolute;\n    bottom: 59px;\n    right: 0;\n    z-index: -1;\n}\n\n/*  faq's section */\n\n\n.frequently-section-fifteen .faq-main-cards .faq-card {\n    box-shadow: 0px 7.5px 17.5px 0px rgba(0, 0, 0, 0.0509803922);\n    background: #ffffff;\n    border-radius: 10px;\n    padding: 15px;\n    margin-bottom: 24px;\n}\n\n.frequently-section-fifteen .faq-main-cards .faq-card .faq-title a {\n    font-size: 20px;\n    color: #000000;\n    width: 100%;\n    font-weight: 600;\n    display: block;\n    position: relative;\n}\n\n.frequently-section-fifteen .faq-main-cards .faq-card .card-collapse p {\n    color: #374151;\n    margin-bottom: 0;\n    margin-top: 15px;\n    padding-top: 15px;\n    border-top: 1px solid #E5E7EB;\n}\n\n.frequently-section-fifteen .faq-main-cards .faq-card .faq-title a:after {\n    content: \"+\";\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    position: absolute;\n    right: 0px;\n    top: 50%;\n    transform: translateY(-50%);\n    transition: 0.5s all;\n    font-family: \"Font Awesome 6 free\";\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 13px;\n}\n\n.frequently-section-fifteen .faq-main-cards .faq-card .faq-title a:not(.collapsed)::after {\n    content: \"\\f068\";\n    background: #0E82FD;\n    color: #ffffff;\n}\n\n.frequently-section-fifteen .faq-main-cards .faq-card .faq-title a:after {\n    content: \"+\";\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    position: absolute;\n    right: 0px;\n    top: 50%;\n    transform: translateY(-50%);\n    transition: 0.5s all;\n    font-family: \"Font Awesome 6 free\";\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 13px;\n}\n\n\n.specialities-section-one {\n    background: none;\n    position: relative;\n}\n\n.specialities-section-one::before {\n    content: \"\";\n    width: 100%;\n    height: 80%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    background: #0E82FD;\n    z-index: -1;\n}\n\n.section-header-one {\n    margin-bottom: 50px;\n    text-align: center;\n}\n\n.specialities-section-one .section-header-one h2 {\n    color: #ffffff;\n}\n\n.section-header-one .section-title {\n    display: inline-block;\n    position: relative;\n}\n.section-header-one h2 {\n    font-size: 30px;\n    font-weight: 600;\n    color: #000000;\n    margin-bottom: 15px;\n}\n\n.specialities-section-one .specialities-block {\n    margin-bottom: 26px;\n}\n\n/* .specialities-section-one .specialities-block .specialities-item {\n    background: #0E82FD;\n    border: 1px solid #ffffff;\n    border-radius: 10px;\n    height: auto;\n    margin: 56px 0 24px;\n    padding: 0 24px 24px;\n    cursor: pointer;\n    -webkit-transition: 0.7s;\n    -ms-transition: 0.7s;\n    transition: 0.7s;\n    display: block;\n} */\n\n/* .specialities-section-one .specialities-block .specialities-img {\n    margin: -56px 0 30px;\n    padding: 0;\n} */\n\n.specialities-section-one .specialities-block .specialities-img .hexogen {\n    border: none;\n    width: 87px;\n    height: 100px;\n    background-repeat: no-repeat;\n    background-position: center;\n    border-radius: 0;\n    -webkit-transition: 0.7s;\n    -ms-transition: 0.7s;\n    transition: 0.7s;\n    margin: 0 auto;\n}\n\n.specialities-section-one .specialities-block .specialities-img .hexogen img {\n    width: auto;\n    -webkit-transition: 0.4s;\n    -ms-transition: 0.4s;\n    transition: 0.4s;\n}\n\n.specialities-wrap {\n    background-image: linear-gradient(53deg, #1383c6, #63bd46) !important;\n    padding: 80px;\n    border-radius: 10px;\n    /* background-image: url(../img/choose-img.jpg); */\n    background-repeat: no-repeat;\n    background-position: right;\n}\n\n.specialities-wrap .special-content h2 {\n    color: #ffffff;\n    font-weight: 600;\n    margin-bottom: 24px;\n}\n\n.specialities-wrap .special-content h4 {\n    color: #ffffff;\n    font-weight: 600;\n    font-size: 20px;\n    margin-bottom: 10px;\n}\n\n.specialities-wrap .special-content p {\n    color: #ffffff;\n    margin-bottom: 40px;\n}\n\n.specialities-wrap .special-content .special-btn a.btn-primary {\n    box-shadow: inset 0 0 0 0 #000C18;\n}\n\n.specialities-wrap .special-content .special-btn a {\n    margin-right: 10px;\n}\n.btn-primary {\n    background-color: #0E82FD;\n    border: 1px solid #0E82FD;\n    box-shadow: inset 0 0 0 0 #ffffff;\n}\n\n.specialities-wrap .special-content .special-btn a:last-child {\n    margin-right: 0;\n}\n\n.specialities-wrap .special-content .special-btn a {\n    margin-right: 10px;\n}\n.btn-outline-primary {\n    background-color: transparent;\n    border: 1px solid #ffffff;\n    box-shadow: inset 0 0 0 0 #ffffff;\n    color: #ffffff;\n}\n.btn {\n    border-radius: 35px;\n    font-weight: 600;\n    font-size: 16px;\n    padding: 11px 24px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
